import { createContext, useContext } from 'react';
import {
  QueryBuilderConfig,
  QueryBuilderState,
  QueryBuilderOnChange,
} from '#coreComponents/QueryBuilder/types';
import { QueryBuilderContextValues } from '../components/QueryBuilderProvider';

interface QueryBuilderContextProps {
  config: Maybe<QueryBuilderConfig>;
  query: Maybe<QueryBuilderOnChange>;
  filters: QueryBuilderState;
  setConfig: (config: QueryBuilderConfig, pageName: string) => void;
  applyChanges: (args: QueryBuilderContextValues) => void;
}

export const defaultContextValue = {
  config: null,
  query: null,
  filters: {
    selectedYears: [],
    querySelectOne: null,
    querySelectTwo: null,
    querySelectThree: null,
    selectedFilters: {},
  },
  setConfig: () => {},
  applyChanges: () => {},
};

export const QueryBuilderContext = createContext<QueryBuilderContextProps>(
  defaultContextValue,
);

export const useQueryBuilder = () => useContext(QueryBuilderContext);

export default QueryBuilderContext;
